export let texts = [
    {
        "id": "databinding",
        "name":"Data Binding",
        "title": "Data Binding",
        "body": `
            Some times you want to carry over user data from once screen to another. For these kind of scenerios
            you can use the data binding functionality. You can also use data bining in the Logic Operators.
        `,
        "video": {
            "src": "https://www.youtube.com/embed/h1C0jbQHlbU"
        }
    }
]